import { render, staticRenderFns } from "./exams.vue?vue&type=template&id=126690b3&scoped=true&"
import script from "./exams.vue?vue&type=script&lang=js&"
export * from "./exams.vue?vue&type=script&lang=js&"
import style0 from "./exams.vue?vue&type=style&index=0&id=126690b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126690b3",
  null
  
)

export default component.exports